import request from '@/libs/request';

// 考卷列表
export const GetExaminationPaperList = (data) => request('GetExaminationPaperList', data);
